<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">

              </h6>
              <div class="element-box-tp">

              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: 'region',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regions/list.vue